import React from 'react'
import styled from 'styled-components'
import { Divider, CurrencyIcon, InputWithIconContainer, LabelContainer, StyledInputField } from '../../shared.styles'

const DonationContainer = styled.div`
  padding: 12px 0px 12px 0px;
  display: flex;
  flex-wrap: wrap;
`

const Donation = ({ label, index, handleChange, value, fund }) => {
  return (
    <div>
      <DonationContainer>
        <LabelContainer>
          <h6>{label}</h6>
        </LabelContainer>
        <InputWithIconContainer>
          <StyledInputField
            type='text'
            width='150px'
            textAlign='right'
            value={value}
            role='textbox'
            maxLength={15}
            onChange={handleChange(fund)}
          />
          <CurrencyIcon>$</CurrencyIcon>
        </InputWithIconContainer>
      </DonationContainer>
      {
        index % 2
          ? null
          : <Divider />
      }
    </div>
  )
}

export default Donation
